import { Checkbox } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
export function CheckboxCell(props) { return /*#__PURE__*/ _jsx("div", { style: { display: "flex", justifyContent: "center" }, children: /*#__PURE__*/ _jsx(Checkbox, { checked: props.value.toString() === "true", size: "small", onChange: function (e) { props.onChange(e.target.checked); } }) }); }
